import { API_BASE_URL } from './config';
import { apiFetch } from './apiFetch';

const JSON_HEADERS = { 'Content-Type': 'application/json' };

export type Box9Employee = {
  id: string;
  employeeId: string;
  companyId: string;
  performance: number;
  potential: number;
  quadrant: string;
  reasoning?: string;
  calculatedAt: string;
  source?: string;          // 'manual' | 'ai' | 'auto_threshold'
  needsAiReview?: boolean;  // true when auto-updated from metric snapshot
};

export type Box9Matrix = {
  star: number;
  'high-performer': number;
  solid: number;
  'future-star': number;
  'high-potential': number;
  average: number;
  'question-mark': number;
  underperformer: number;
  'low-performer': number;
};

export async function getBox9Employees(companyId: string, _token?: string) {
  const response = await apiFetch(`${API_BASE_URL}/api/box9-grid/employees?companyId=${companyId}`);
  return response.json() as Promise<{ success: boolean; data?: { employees: Box9Employee[] }; error?: string }>;
}

export async function positionEmployee(
  employeeId: string,
  companyId: string,
  performance: number,
  potential: number,
  _token?: string,
) {
  const response = await apiFetch(`${API_BASE_URL}/api/box9-grid/employees/${employeeId}/position?companyId=${companyId}`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ performance, potential }),
  });
  return response.json() as Promise<{ success: boolean; data?: { position: Box9Employee }; error?: string }>;
}

export async function getBox9Matrix(companyId: string, _token?: string) {
  const response = await apiFetch(`${API_BASE_URL}/api/box9-grid/matrix?companyId=${companyId}`);
  return response.json() as Promise<{ success: boolean; data?: { matrix: Box9Matrix }; error?: string }>;
}

export type Box9GridConfig = {
  performanceThresholds: { low: number; medium: number };
  potentialThresholds: { low: number; medium: number };
};

export async function getGridConfig(companyId: string, _token?: string) {
  const response = await apiFetch(`${API_BASE_URL}/api/box9-grid/config?companyId=${companyId}`);
  return response.json() as Promise<{ success: boolean; data?: { config: Box9GridConfig }; error?: string }>;
}

export async function updateGridConfig(companyId: string, config: Box9GridConfig, _token?: string) {
  const response = await apiFetch(`${API_BASE_URL}/api/box9-grid/config`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify({ companyId, ...config }),
  });
  return response.json() as Promise<{ success: boolean; data?: { config: Box9GridConfig }; error?: string }>;
}

export async function calculatePositions(companyId: string, _token?: string) {
  const response = await apiFetch(`${API_BASE_URL}/api/box9-grid/calculate`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ companyId }),
  });
  return response.json() as Promise<{ success: boolean; data?: { positioned: number }; error?: string }>;
}
